import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from '../../../layout/header/header.component';
import {
  ConfirmEventType,
  ConfirmationService,
  MenuItem,
  Message,
  MessageService,
  SelectItem,
  TreeNode,
} from 'primeng/api';
import { Table } from 'primeng/table';
import { DataService } from 'src/app/services/data.service';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import icons from '../../../../misc/data/icons.json';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import entities from '../../../../misc/data/entities.json';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { PERMISSION_INTERFACES } from '../../../../misc/data/permissions';
import { PermissionUpdateHandlerService } from 'src/app/services/permission-update-handler.service';
import { Router } from '@angular/router';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class PermissionsComponent {
  skelition = true;
  globalFilter: string = ''
  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  @ViewChild('dt')
  dt!: Table;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];
  header = this.translate('Organization of powers');
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-chevron-circle-right',
      link: '/admin/users/roles',
      visible: this.permissionService.hasPermission('ROLE_MANAGEMENT', 'r'),
    },
    {
      name: 'إنشاءالصلاحيات',
      icon: 'pi pi-chevron-circle-right',
      link: '/admin/users/roles/permission/add',
      visible: this.permissionService.hasPermission(
        'PERMISSION_MANAGEMENT',
        'c'
      ),
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('User console'), link: '/admin/users' },
    { name: this.translate('Organizing roles'), link: '/admin/users/roles' },
    { name: this.translate('Powers'), link: '/admin/users/roles/permission' },
  ];
  stats: stat[] = [];

  maxID = entities.reduce((prev: any, current: any) => {
    return prev.id > current.id ? prev : current;
  }).id;

  PermissionData: any[] = [];
  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  constructor(
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    private orgUnits: OrgUnitsService,
    public permissionService: PermissionHandlerService,
    private permissionUpdateService: PermissionUpdateHandlerService,
    private router: Router,
  ) { }

  ngOnInit() {
    Promise.all([this.getPermissions()]).then((e) => {
      this.mapPermissionData();
      this.skelition = false;
    });
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });
  }
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  hasPermission(flag: string) {
    return this.permissionService.hasPermission('PERMISSION_MANAGEMENT', flag);
  }

  mapPermissionData() {
    this.data = [];
    this.PermissionData.forEach((pData: any) => {
      let node: TreeNode = {
        data: {
          permissionName: pData.name,
          active: pData.active,
          unitName: '-',
          _id: pData._id,
          ou: '-',
          read: '-',
          write: '-',
          update: '-',
          delete: '-',
          allow: '-',
          disallow: '-'
        },
        children: [],
      };
      pData.permissions.forEach((parent: any) => {
        node.children?.push({
          data: {
            permissionName: pData.name,
            unitName: parent.arabic || '-',
            ou: parent.ouRequired ? parent.ouLabel : '-',
            read: parent.options.options.read || '-',
            write: parent.options.options.write || '-',
            update: parent.options.options.update || '-',
            delete: parent.options.options.delete || '-',
            allow: parent.options.options.allow || '-',
            disallow: parent.options.options.disallow || '-',
          },
          children:
            parent.children && parent.children.length > 0
              ? parent.children.map((child: any) => {
                return {
                  data: {
                    permissionName: pData.name,
                    unitName: child.arabic || '-',
                    ou:
                      child.ouRequired ? parent.ouLabel
                        : '-',
                    read: child.options.options.read || '-',
                    write: child.options.options.write || '-',
                    update: child.options.options.update || '-',
                    delete: child.options.options.delete || '-',
                    allow: child.options.options.allow || '-',
                    disallow: child.options.options.disallow || '-',
                  },
                };
              })
              : [],
        });
      });
      this.data.push(node);
    });

    console.log('NODES', this.data);
    this.cols = [
      { field: 'permissionName', header: 'اسم الصلاحية' },
      { field: 'unitName', header: 'الواجهة' },
      { field: 'ou', header: 'الوحدةالتنظيمية' },
      { field: 'read', header: 'قراءة' },
      { field: 'write', header: 'كتابة' },
      { field: 'update', header: 'تحديث' },
      { field: 'delete', header: 'حذف' },
      { field: 'allow', header: 'سماح' },
      { field: 'disallow', header: 'حظر' },
      { field: 'active', header: 'الحالة' },
      { field: 'Action', header: 'خيارات أخرى' },
    ];
  }

  private updatePermissionCount(): void {
    if (this.PermissionData) {
      console.log(this.PermissionData);
      let activePermissions = this.PermissionData.filter(
        (data: any) => data.active === true
      ).length;
      let inactivePermissions = this.PermissionData.length - activePermissions;
      this.stats = [
        {
          name: this.translate('active'),
          number: activePermissions,
          icon: 'pi pi-check-circle',
        },
        {
          name: this.translate('Inactive'),
          number: inactivePermissions,
          icon: 'pi pi-times-circle',
        },
      ];
    }
  }

  // Add Table Configuration
  getPermissions = async () => {
    try {
      let res = await this.dataService.getData('permission');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.PermissionData = res.data;
      this.updatePermissionCount();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    console.log($event);
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deletePosition($event.id),
        });
        break;
      case 'Update':
        let updateData = $event.data;
        this.permissionUpdateService.permissionData = this.PermissionData.find(e => e._id == updateData.node.data._id);
        console.log(this.permissionUpdateService.permissionData);
        this.router.navigate(['admin/users/roles/permission/add']);
    }
  }

  deletePosition = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`permission/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];

      this.PermissionData = this.PermissionData.filter(
        (data) => data._id !== id
      );
      this.mapPermissionData();
      this.updatePermissionCount();
    } catch (error) {
      console.log(error);
    }
  };
  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
